/**
 * Safari with privacy options will have localStorage but won't let us write to it.
 * Android WebView might not have localStorage at all.
 * If app is embedded in an iframe, then in Chrome Incognito accessing localStorage throws.
 */

import * as log from 'src/lib/log';

const memoryStorage = {};

const getBrowserStorage = (options) => {
  const { session } = options || {};
  return session ? window.sessionStorage : window.localStorage;
};

export function readItem(key, options) {
  let value;

  try {
    const browserStorage = getBrowserStorage(options);
    if (browserStorage) {
      value = browserStorage.getItem(key);
    } else {
      value = memoryStorage[key];
    }
  } catch (e) {
    log.warning('Browser storage is not available, error reading');
  }

  return value !== null ? value : null;
}

export function writeItem(key, value, options) {
  try {
    const browserStorage = getBrowserStorage(options);
    if (browserStorage) {
      browserStorage.setItem(key, value);
    } else {
      memoryStorage[key] = value;
    }
  } catch (e) {
    log.warning('Browser storage is not available, error writing');
    memoryStorage[key] = value;
  }
}

export function removeItem(key, options) {
  try {
    const browserStorage = getBrowserStorage(options);
    if (browserStorage) {
      browserStorage.removeItem(key);
    } else {
      delete memoryStorage[key];
    }
  } catch (e) {
    log.warning('Browser storage is not available, error removing');
  }
}
